module.exports = __webpack_public_path__ + "media/images/double_minimize-2118a6088f5294366f9be05f2f59a295.svg";